<div id="linkbar-wrapper" class="k-pos-sticky k-top-0">
  <ul id="linkbar" class="k-list-none k-p-0">
    <li>Nichtarbeitszeit</li>
    <li>Zeitaufzeichnung</li>
  </ul>
</div>
